/**************************************************
 * Nombre:       Home_Tradicion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import trofeo from '../../../Recursos/ic_trofeo.svg'
import confianza from '../../../Recursos/ic_confianza.svg'
import compania from '../../../Recursos/ic_compania.svg'
import tranui from '../../../Recursos/ic_tranquilidad.svg'
import negrita from '../../../Recursos/negrita.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Tradicion = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: theme.palette.primary.main}}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 5}}
            >
                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{color: '#fff'}}
                            >


                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 32, fontWeight: 800, lineHeight: 1.2}}>Tradición, Cultura
                                        y
                                        Fiesta</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>San Andrés, una isla del Caribe
                                        colombiano, tiene una cultura vibrante que es una fusión de influencias
                                        africanas, europeas, caribeñas y latinoamericanas. Esta mezcla única se refleja
                                        en sus tradiciones, cultura y fiestas, que son esenciales para entender la
                                        identidad de su población, conocida como raizal.</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 500}}>En Receptour, te acompañamos a
                                        descubrirla, nos diferenciamos en:</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 8}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-end'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={sCell ? 2 : 0}
                                    >


                                        {caracteristicas.map((it, index) => {
                                            return (
                                                <Grid container size={{xs: 6, sm: 3, md: 3}}
                                                      sx={{justifyContent: 'center'}}>
                                                    <Grid
                                                        container
                                                        justifyContent={'flex-start'}
                                                        alignItems={'flex-start'}
                                                        size={{xs: 12, sm: 12, md: 12}}>


                                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                              sx={{justifyContent: 'center'}}>
                                                            <img src={it.imagen} width={it.w} height={'auto'}/>
                                                        </Grid>

                                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                              sx={{justifyContent: 'center', mt: it.mt}}>
                                                            <Typography sx={{
                                                                fontSize: 14,
                                                                fontWeight: 400
                                                            }}>{it.nombre}</Typography>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            )
                                        })}

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 2 : -44.5, mb: -5}}>
                            <img src={negrita} width={'90%'} height={'auto'}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Tradicion

const caracteristicas = [
    {
        nombre: 'Calidad',
        imagen: trofeo,
        w: 38,
        mt: 1
    },
    {
        nombre: 'Confianza',
        imagen: confianza,
        w: 42,
        mt: 2
    },
    {
        nombre: 'Compañia',
        imagen: compania,
        w: 46,
        mt: 1.5
    },
    {
        nombre: 'Tranquilidad',
        imagen: tranui,
        w: 42,
        mt: 1.5
    },
]